import React, { useEffect, useState } from 'react';

import { wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';

import Modal from 'components/Tvendo/Common/ModalBase';

//reemplazando valores de iniciales en estado

export default function ModalSpZone(props) {
  const zone = props.model;

  const [dataChanging, setDataChanging] = useState(zone);
  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  const [zones, setZones] = useState([]);
  async function listZones(zoneExists) {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      const data = response.data.filter(
        ({ id: id1 }) => !zoneExists.some(({ id: id2 }) => id2 === id1)
      );
      setZones(data);
    }
  }

  useEffect(() => {
    if (props.supervisor.zones !== undefined && zone.open) {
      listZones(props.supervisor.zones);
    }
  }, [props.supervisor.zones, zone.open]);

  return (
    <Modal
      title="Zona"
      model={zone}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity={'base/supervisor/' + props.supervisorId + '/zone'}
    >
      <Autocomplete
        options={zones}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => <TextField {...params} label="Zonas" margin="normal" />}
        onChange={(e, item) => {
          if (!!item) {
            handleChange('base_zone_id', item.id);
          } else {
            handleChange('base_zone_id', null);
          }
        }}
      />
    </Modal>
  );
}
